import React, { useState, useRef, useEffect } from "react";
import { Search, Star, Globe, Server, Shield, Smartphone, Database, Cloud, Monitor, Wifi, Code, CheckCircle, ArrowRight } from "lucide-react";

const useInView = () => {
  const ref = useRef(null);
  const [v, setV] = useState(false);
  useEffect(() => {
    const el = ref.current; if (!el) return;
    const o = new IntersectionObserver(([e]) => { if (e.isIntersecting) { setV(true); o.disconnect(); } }, { threshold: 0.08 });
    o.observe(el); return () => o.disconnect();
  }, []);
  return [ref, v];
};

const productsData = [
  { id: 1, title: "Business Management Suite", cat: "software", icon: Code, img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&auto=format&fit=crop&q=60", price: "From $299/mo", rating: 4.8, desc: "Complete ERP/CRM solution for modern businesses", features: ["CRM & Lead Management", "Inventory & Financials", "Multi-user Access Control", "API Integration Ready", "Analytics Dashboards", "Mobile App Included"], badge: "Popular" },
  { id: 2, title: "Cloud Dashboard Platform", cat: "software", icon: Cloud, img: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=600&auto=format&fit=crop&q=60", price: "From $199/mo", rating: 4.7, desc: "Unified multi-cloud management interface", features: ["Multi-Cloud Monitoring", "Cost Optimization", "Resource Management", "Performance Analytics", "Automated Alerts", "Custom Reporting"], badge: "New" },
  { id: 3, title: "Security Monitoring Tool", cat: "software", icon: Shield, img: "https://images.unsplash.com/photo-1550751827-4bd374c3f58b?w=600&auto=format&fit=crop&q=60", price: "From $149/mo", rating: 4.9, desc: "Real-time threat detection and response system", features: ["24/7 Threat Monitoring", "AI-Powered Detection", "Incident Response", "Compliance Reporting", "Vulnerability Scanning", "Forensic Tools"], badge: "Enterprise" },
  { id: 4, title: "Mobile App Framework", cat: "software", icon: Smartphone, img: "https://images.unsplash.com/photo-1512941937669-90a1b58e7e9c?w=600&auto=format&fit=crop&q=60", price: "From $99/mo", rating: 4.6, desc: "Ready-to-customize mobile app templates", features: ["iOS & Android Templates", "Drag & Drop Builder", "Pre-built Components", "Push Notifications", "Offline Functionality", "App Store Deploy"], badge: "" },
  { id: 5, title: "Enterprise Server Package", cat: "hardware", icon: Server, img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&auto=format&fit=crop&q=60", price: "From $2,999", rating: 4.8, desc: "High-performance rack servers with support", features: ["Intel Xeon Processors", "Up to 1TB RAM", "RAID Configuration", "Redundant Power", "Remote Management", "3-Year Warranty"], badge: "Best Value" },
  { id: 6, title: "Network Security Appliance", cat: "hardware", icon: Shield, img: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&auto=format&fit=crop&q=60", price: "From $1,499", rating: 4.7, desc: "Next-gen firewall with intrusion prevention", features: ["Next-Gen Firewall", "Intrusion Prevention", "VPN Gateway", "Content Filtering", "DDoS Protection", "Central Management"], badge: "" },
  { id: 7, title: "Wireless Network Solution", cat: "hardware", icon: Wifi, img: "https://pronto-core-cdn.prontomarketing.com/2/wp-content/uploads/sites/595/2017/12/Wireless-networking.jpg", price: "From $899", rating: 4.9, desc: "Enterprise-grade wireless access points", features: ["Wi-Fi 6 Technology", "High-Density Support", "Seamless Roaming", "Advanced Security", "Cloud Management", "PoE Support"], badge: "Wi-Fi 6" },
  { id: 8, title: "Backup & Recovery System", cat: "hardware", icon: Database, img: "https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?w=600&auto=format&fit=crop&q=60", price: "From $1,999", rating: 4.8, desc: "Automated backup with disaster recovery", features: ["Automated Daily Backups", "Instant Recovery", "Cloud Integration", "Deduplication", "Encryption at Rest", "Compliance Ready"], badge: "" },
  { id: 9, title: "Starter Cloud Package", cat: "cloud", icon: Cloud, img: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&auto=format&fit=crop&q=60", price: "From $99/mo", rating: 4.6, desc: "Basic cloud migration and setup service", features: ["Migration Assessment", "Basic Setup", "Data Transfer", "Security Config", "Training & Docs", "30-Day Support"], badge: "Starter" },
  { id: 10, title: "Enterprise Cloud Suite", cat: "cloud", icon: Globe, img: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=600&auto=format&fit=crop&q=60", price: "From $499/mo", rating: 4.9, desc: "Complete multi-cloud management solution", features: ["Multi-Cloud Arch.", "Load Balancing", "Auto-Scaling", "Disaster Recovery", "Perf Monitoring", "24/7 Support"], badge: "Enterprise" },
  { id: 11, title: "CI/CD Dev Environment", cat: "cloud", icon: Code, img: "https://images.unsplash.com/photo-1555066931-4365d14bab8c?w=600&auto=format&fit=crop&q=60", price: "From $199/mo", rating: 4.7, desc: "Complete CI/CD pipeline and testing platform", features: ["Continuous Integration", "Automated Testing", "Code Quality", "Deploy Automation", "Version Control", "Team Collab"], badge: "DevOps" },
  { id: 12, title: "24/7 Monitoring Service", cat: "services", icon: Monitor, img: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600&auto=format&fit=crop&q=60", price: "From $79/mo", rating: 4.8, desc: "Continuous system health monitoring", features: ["Real-time Monitoring", "Performance Alerts", "Uptime Reporting", "Capacity Planning", "Incident Response", "Monthly Reports"], badge: "24/7" },
];

const cats = [
  { id: "all", label: "All Products", icon: Globe },
  { id: "software", label: "Software", icon: Code },
  { id: "hardware", label: "Hardware", icon: Server },
  { id: "cloud", label: "Cloud", icon: Cloud },
  { id: "services", label: "Services", icon: Monitor },
];

const badgeStyle = (b) => {
  const m = { popular: "#f59e0b", new: "#10b981", enterprise: "#8b5cf6", "best value": "#ef4444", starter: "#06b6d4", "wi-fi 6": "#2563eb", devops: "#6366f1", "24/7": "#14b8a6" };
  return { background: m[b?.toLowerCase()] || "#2563eb" };
};

const Card = ({ p, visible, delay }) => (
  <div className={`pc ${visible ? "vis" : ""}`} style={{ transitionDelay: delay }}>
    <div className="pc-img">
      <img src={p.img} alt={p.title} />
      {p.badge && <div className="pc-badge" style={badgeStyle(p.badge)}>{p.badge}</div>}
      <div className="pc-icon-badge"><p.icon size={17} /></div>
    </div>
    <div className="pc-body">
      <div className="pc-head">
        <h3>{p.title}</h3>
        <div className="pc-rating"><Star size={13} fill="currentColor" />{p.rating}</div>
      </div>
      <p className="pc-desc">{p.desc}</p>
      <div className="pc-feats">
        {p.features.slice(0, 4).map((f, i) => (
          <div key={i} className="pc-feat"><CheckCircle size={12} /><span>{f}</span></div>
        ))}
        {p.features.length > 4 && <div className="pc-more">+{p.features.length - 4} more</div>}
      </div>
      <div className="pc-foot">
        <div className="pc-price">{p.price}</div>
        <button className="pc-btn" onClick={() => window.location.href = "/contact"}>Quote <ArrowRight size={13} /></button>
      </div>
    </div>
  </div>
);

export default function Products() {
  const [cat, setCat] = useState("all");
  const [q, setQ] = useState("");
  const [gridRef, gridIn] = useInView();

  const filtered = productsData.filter(p => {
    const mc = cat === "all" || p.cat === cat;
    const mq = !q || p.title.toLowerCase().includes(q.toLowerCase()) || p.desc.toLowerCase().includes(q.toLowerCase());
    return mc && mq;
  });

  return (
    <div className="pp">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@300;400;500;600;700;800&family=Instrument+Serif:ital@0;1&display=swap');
        *{box-sizing:border-box;margin:0;padding:0}
        :root{
        --db:#1d4ed8; /* dark blue */
          --blue:#2563eb;--blue2:#3b82f6;
          --dark:#06070e;--dark2:#0c0e1c;
          --white:#fff;--off:#f7f8fc;
          --txd:#0f1729;--txm:#4a5478;
          --bd:rgba(15,23,41);;
          --f:'Plus Jakarta Sans',sans-serif;--fs:'Instrument Serif',serif;
        }
        .pp{font-family:var(--f);overflow-x:hidden}

        /* ── HERO dark ── */
        .pp-hero{
          position:relative;
          background:var(--dark);
          padding:9rem 1.5rem 5.5rem;
          text-align:center;overflow:hidden;
        }
        .pp-hero-bg{
          position:absolute;inset:0;
          background:radial-gradient(ellipse 75% 55% at 50% -5%,rgba(37,99,235,.2),transparent 65%),var(--dark);
        }
        .pp-hero-grid{
          position:absolute;inset:0;
          background-image:linear-gradient(rgba(255,255,255,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(255,255,255,.04) 1px,transparent 1px);
          background-size:50px 50px;
          mask-image:radial-gradient(ellipse 80% 70% at 50% 50%,#000 25%,transparent 100%);
        }
        .pp-hero-con{position:relative;z-index:1;max-width:680px;margin:0 auto}
        .lbl{display:inline-block;font-size:.67rem;font-weight:800;letter-spacing:.18em;text-transform:uppercase;color:var(--blue2);margin-bottom:.85rem}
        .pp-h1{
          font-size:clamp(2rem,4vw,3.6rem);font-weight:800;
          letter-spacing:-.04em;line-height:1.08;
          background:linear-gradient(135deg,#fff 40%,#93c5fd);
          -webkit-background-clip:text;-webkit-text-fill-color:transparent;background-clip:text;
          margin-bottom:1.1rem;
          animation:fadeUp .8s cubic-bezier(.16,1,.3,1) .15s both;
        }
        .pp-sub{
          font-size:.93rem;font-weight:400;line-height:1.72;color:rgba(24, 23, 23, 0.45);
          color:rgba(255,255,255,.45);max-width:500px;margin:0 auto;
          animation:fadeUp .8s cubic-bezier(.16,1,.3,1) .3s both;
        }

        /* ── PRODUCT SECTION white ── */
        .pp-body{background:var(--off);padding:5rem 1.5rem 7rem}
        .pp-wrap{max-width:1300px;margin:0 auto}

        /* filter bar - glassmorphism style */
        .pp-filters{
          background:rgba(255,255,255,.85);
          backdrop-filter:blur(20px);
          border:1px solid var(--bd);
          border-radius:16px;padding:1.35rem 1.5rem;
          margin-bottom:2.5rem;
          display:flex;align-items:center;justify-content:space-between;
          flex-wrap:wrap;gap:1rem;
          box-shadow:0 4px 24px rgba(37,99,235,.06);
          position:sticky;top:80px;z-index:10;
        }
        .pp-cats{display:flex;gap:.5rem;flex-wrap:wrap}
        .cat-btn{
  display:flex;
  align-items:center;
  gap:.4rem;

  background:rgba(37,99,235,0.08); /* light blue bg */
  border:1px solid rgba(37,99,235,0.25);

  border-radius:8px;
  color:#1d4ed8; /* ✅ dark blue text ALWAYS */

  cursor:pointer;
  font-family:var(--f);
  font-size:.75rem;
  font-weight:700;

  letter-spacing:.05em;
  text-transform:uppercase;
  padding:.52rem .95rem;

  transition:all .2s ease;
}
        .cat-btn:hover{border-color:rgba(37,99,235,.35);color:var(--txd)}
        .cat-btn.act{background:var(--blue);border-color:var(--blue);color:#fff;box-shadow:0 4px 14px rgba(37,99,235,.3)}
        .pp-search{position:relative;max-width:240px;width:100%}
        .pp-search svg{position:absolute;left:.85rem;top:50%;transform:translateY(-50%);color:var(--txm);pointer-events:none}
        .pp-search input{
          width:100%;padding:.62rem 1rem .62rem 2.4rem;
          background:#fff;border:1px solid var(--bd);border-radius:9px;
          color:var(--txd);font-family:var(--f);font-size:.875rem;outline:none;
          transition:all .2s ease;
        }
        .pp-search input::placeholder{color:rgba(74,84,120,.4)}
        .pp-search input:focus{border-color:rgba(37,99,235,.45);box-shadow:0 0 0 3px rgba(37,99,235,.1)}

        /* grid */
        .pp-grid{
          display:grid;
          grid-template-columns:repeat(auto-fill,minmax(300px,1fr));
          gap:1.4rem;
        }

        /* card */
        .pc{
          background:var(--white);
          border:1px solid var(--bd);
          border-radius:16px;overflow:hidden;
          transition:all .3s cubic-bezier(.34,1.56,.64,1);
          opacity:0;transform:translateY(24px);
        }
        .pc.vis{opacity:1;transform:translateY(0)}
        .pc:hover{border-color:rgba(37,99,235,.28);transform:translateY(-7px);box-shadow:0 16px 48px rgba(37,99,235,.1)}

        .pc-img{position:relative;height:180px;overflow:hidden}
        .pc-img img{width:100%;height:100%;object-fit:cover;filter:brightness(.92) saturate(.9);transition:all .4s ease}
        .pc:hover .pc-img img{filter:brightness(1) saturate(1);transform:scale(1.06)}
        .pc-badge{
          position:absolute;top:.85rem;left:.85rem;padding:.22rem .65rem;
          border-radius:100px;font-size:.65rem;font-weight:700;
          letter-spacing:.07em;text-transform:uppercase;color:#fff;
        }
        .pc-icon-badge{
          position:absolute;top:.85rem;right:.85rem;width:33px;height:33px;
          border-radius:9px;background:rgba(255,255,255,.9);
          backdrop-filter:blur(8px);color:var(--blue);
          display:flex;align-items:center;justify-content:center;
          border:1px solid rgba(37,99,235,.2);
        }

        .pc-body{padding:1.2rem}
        .pc-head{display:flex;justify-content:space-between;align-items:flex-start;gap:.5rem;margin-bottom:.45rem}
        .pc-head h3{font-size:.9rem;font-weight:700;color:var(--txd);line-height:1.3;letter-spacing:-.01em}
        .pc-rating{display:flex;align-items:center;gap:.25rem;color:#f59e0b;font-size:.78rem;font-weight:700;flex-shrink:0;white-space:nowrap}
        .pc-desc{
  font-size:.79rem;
  color:var(--bd); /* changed */
  line-height:1.55;
  margin-bottom:.85rem;
}
        .pc-feats{margin-bottom:1.1rem;display:flex;flex-direction:column;gap:.35rem}
        .pc-feat{display:flex;align-items:center;gap:.45rem;font-size:.77rem;color:var(--bd)}
        .pc-feat svg{color:#10b981;flex-shrink:0}
        .pc-more{font-size:.7rem;color:var(--bd);padding-left:1.35rem;font-style:italic}
        .pc-foot{display:flex;align-items:center;justify-content:space-between;padding-top:.9rem;border-top:1px solid var(--bd)}
        .pc-price{font-size:.9rem;font-weight:800;color:var(--txd);letter-spacing:-.02em}
        .pc-btn{
          display:flex;align-items:center;gap:.35rem;
          background:var(--blue);border:none;border-radius:8px;color:#fff;
          cursor:pointer;font-family:var(--f);font-size:.72rem;font-weight:700;
          letter-spacing:.05em;text-transform:uppercase;padding:.55rem 1rem;
          transition:all .25s ease;
        }
        .pc-btn:hover{background:#1d4ed8;transform:translateY(-2px);box-shadow:0 6px 18px rgba(37,99,235,.35)}

        /* empty */
        .pp-empty{text-align:center;padding:5rem 2rem;color:var(--txm)}
        .pp-empty h3{font-size:1.4rem;font-weight:700;color:var(--txd);margin-bottom:.5rem}

        @keyframes fadeUp{from{opacity:0;transform:translateY(26px)}to{opacity:1;transform:translateY(0)}}

        @media(max-width:768px){
          .pp-filters{flex-direction:column;align-items:stretch;position:relative;top:0}
          .pp-search{max-width:none}
          .pp-grid{grid-template-columns:1fr}
        }
      `}</style>

      {/* DARK HERO */}
      <div className="pp-hero">
        <div className="pp-hero-bg" /><div className="pp-hero-grid" />
        <div className="pp-hero-con">
          <div className="lbl">Our Products</div>
          <h1 className="pp-h1">IT Products</h1>
          <p className="pp-sub">Software, hardware, cloud services and managed solutions — everything to power your business forward.</p>
        </div>
      </div>

      {/* WHITE BODY */}
      <div className="pp-body">
        <div className="pp-wrap">
          {/* Glass filter bar */}
          <div className="pp-filters">
            <div className="pp-cats">
              {cats.map(({ id, label, icon: Icon }) => (
                <button key={id} className={`cat-btn ${cat === id ? "act" : ""}`} onClick={() => setCat(id)}>
                  <Icon size={13} />{label}
                </button>
              ))}
            </div>
            <div className="pp-search">
              <Search size={14} />
              <input type="text" placeholder="Search products…" value={q} onChange={e => setQ(e.target.value)} />
            </div>
          </div>

          {/* Products grid */}
          {filtered.length > 0 ? (
            <div className="pp-grid" ref={gridRef}>
              {filtered.map((p, i) => (
                <Card key={p.id} p={p} visible={gridIn} delay={`${(i % 4) * 0.07}s`} />
              ))}
            </div>
          ) : (
            <div className="pp-empty">
              <h3>No products found</h3>
              <p>Try a different category or search term.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
